export default __webpack_public_path__ + "static/media/liex-04.19680cd2.png";